import {REPORT_EARNED_CLIENT_SUPPORT_BONUS_PLUS} from '/enum/records.enum';

export default {
  reportName: REPORT_EARNED_CLIENT_SUPPORT_BONUS_PLUS,
};
